import config from '../SysConfig.json';

export class attachHelper {
    static async uploadFile(file: File,subdir:string) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('sourceFileName', file.name);
  
        try {
          const updDir=(subdir==='') ? config.uploadDirectiory: config.uploadDirectiory+"/"+subdir;
          const response = await fetch(`/api/storage/private/${updDir}`, {
            method: 'POST',
            body: formData,
          });
    
          if (response.ok) {
            const data = await response.json();
            return data;         
          } else {
            throw new Error('Failed to upload file');
          }
        } catch (error) {
          console.error('Error uploading file:', error);      
        }
    }
    static async deleteFile(fileName:string,subdir:string) {
        try {
            const updDir=(subdir==='') ? config.uploadDirectiory: config.uploadDirectiory+"/"+subdir;
            const response = await fetch(`/api/storage/private/${updDir}/${fileName}`, {
                method: 'DELETE',
            });
            if (response.ok) {
                const data = await response.json();
                return data;
            } else {
                throw new Error('Failed to delete file');
            }
        } catch (error) {
            console.error('Error deleting file:', error);
        }
    }
}


